import { createSlice } from '@reduxjs/toolkit';

import { setGeoLocationStatus } from './actions';

export type LocationPoint = {
    latitude: number;
    longitude: number;
};

export interface GeoLocationState {
    location?: LocationPoint;
    allowed?: boolean;
}

const initialState = {} as GeoLocationState;

const geoLocationSlice = createSlice({
    name: 'geoLocation',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(setGeoLocationStatus, (state, { payload }) => payload);
    },
});

export default geoLocationSlice.reducer;
